<template>
    <page>
        <module :title="id ? '编辑成功案例' : '添加成功案例'">
            <c-form ref="form" unit-width="500">
                <c-form-item label="标题" width="800px" required>
                    <c-input name="case_title"></c-input>
                </c-form-item>
                <c-form-item label="封面图" width="800px" required>
                    <c-upload-file name="img_url" media type="image" tip="请上传一张封面图片，文件大小建议5M以内"></c-upload-file>
                </c-form-item>
                <c-form-item  label="内容" width="800px" required>
                    <c-editor name="case_content" ></c-editor>
                </c-form-item>
            </c-form>
            <template slot="button">
                <c-button color="main" size="form" @click="submit()">提交发布</c-button>
            </template>
        </module>
    </page>
</template>

<script>
var sroutes = {
    path: '/success_case_list',  //列表页在routes中的path
    name: 'm_success_case',  //列表页在routes中的name
    update: 'successCaseUpdate', //列表页定义的返回刷新的方法
    url_detail:'/success_case/detail',  //获取详情的url地址
    url_update:'/success_case/update',  //编辑提交地址
    url_add:'/success_case/add',  //新增地址
};
var name = 'm_success_case';
export default {
    name: name,

    props: {
        id: String
    },

    data() {
        return {

        }
    },

    computed: {

    },

    watch: {
        id() {
            this.getDetail();
        },
    },

    mounted() {
        if (this.id) {
            this.getDetail();
        }
    },

    methods: {
        getDetail() {
            this.request({
                url: sroutes.url_detail,
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.$refs.form.set(data);
                }
            });
        },

        submit(type) {
            this.$refs.form.submit({
                url: this.id ? sroutes.url_update : sroutes.url_add,
                rule: {
                    case_title: '请填写标题',
                    img_url: '请上传封面图',
                    case_content: '请填写内容',
                },
                dataFormatter: data => {
                    // 提交前处理数据格式
                    if( this.id ){
                        data.id = this.id;
                    }
                    return data;
                },
                success: () => {
                    this.$message({
                        type: 'success',
                        message: '保存成功'
                    });
                    this.navigateTo('/success_case_list');
                }
            });
        }
    }
}
</script>
